import { render, staticRenderFns } from "./o-pagination.vue?vue&type=template&id=6465438d&scoped=true&"
import script from "./o-pagination.vue?vue&type=script&lang=js&"
export * from "./o-pagination.vue?vue&type=script&lang=js&"
import style0 from "./o-pagination.vue?vue&type=style&index=0&id=6465438d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6465438d",
  null
  
)

export default component.exports